import React, { useEffect,Suspense } from 'react'  
//import TopSlider from '../components/about/TopSlider'
const TopSlider = React.lazy(() => import('../components/about/TopSlider'));

//import InfoWithImage from '../components/about/InfoWithImage'
const InfoWithImage = React.lazy(() => import('../components/about/InfoWithImage'));

//import Services from '../components/about/Services'
const Services = React.lazy(() => import('../components/about/Services'));

//import KeyValue from '../components/about/KeyValue'
const KeyValue = React.lazy(() => import('../components/about/KeyValue'));

import { useAppContext } from "../Context/Store";

export default function About({ sendBodyClass }) {
  const { isError, isLoading, AboutData } = useAppContext();
 
  const { properties } = AboutData;

  useEffect(() => {
    sendBodyClass(false);
  },[])
  return (
    <>
    <Suspense fallback={<div>Loading...</div>}> 
      <TopSlider 
        SliderDataDynamic={properties?.slider?.items || "Top Slider Data Missing"}
      /> 
        
      <InfoWithImage 
        LeftTextDataDynamic={properties?.leftText?.markup || "InfoWithImage Left Text Data Missing"} 
        RightImageDataDynamic={properties?.rightImage || "InfoWithImage Right Image Data Missing"} 
        CircleTextDataDynamic={properties?.circleText || "InfoWithImage Left Circle Data Missing"}
      />
        <Services ServicesItemsDataDynamic={properties?.servicesItems.items || "About Services Data Missing"} />
        <KeyValue 
          OurMissionLeftTextDataDynamic={properties?.ourMissionLeftText?.markup || "Our Mission Left Text Data Missing"} 
          OurMissionRightItemsDataDynamic={properties?.ourMissionItems.items || "Our Mission Right Items Data Missing"} />
        </Suspense>
    </>
  )
}
